import {MuiInput} from './MuiInput';
import { MuiButton } from "./MuiButton";
export default function ComponentsOverrides(theme){
    return Object.assign(
        MuiInput(theme),
        MuiButton(theme)
    )
}